import styled from "styled-components";
import Video from "../Video/Video";
import Image from "../Image/Image";

export const ItemCard = styled.div`
  border-radius: 6px;
  overflow: clip;
  position: relative;
`;

export const StyledVideo = styled(Video)`
  aspect-ratio: unset;
  height: 100%;
`;

export const StyledImage = styled(Image)`
  aspect-ratio: unset;
  height: 100%;
`;

export const Badge = styled.span`
  border-radius: 100px;
  background: ${(props) => {
    if (props.$variant === "Free Trial") {
      return "linear-gradient(90deg, #2D72C7 0%, #2A7DE4 100%)";
    } else if (props.$variant === "Popular") {
      return "linear-gradient(90deg, #D2124F 0%, #FAA835 100%)";
    } else if (props.$variant === "New") {
      return "linear-gradient(90deg, #85CAA8 0%, #7CB398 100%)";
    } else if (props.$variant === "Trending") {
      return "linear-gradient(180deg, #1F6BAF 0%, #0D1C33 100%)";
    } else if (props.$variant === "Santa's Special") {
      return "linear-gradient(90deg, #82131A 0%, #C02F3C 56.25%, #5A161C 100%)";
    }
    return "linear-gradient(90deg, #2877D9 0%, #153F73 100%)";
  }};

  border: ${(props) => {
    if (props.$variant === "Free Trial") {
      return "0.5px solid #2876D7";
    } else if (props.$variant === "New") {
      return "0.5px solid #8DD1AA";
    } else if (props.$variant === "Popular") {
      return "0.5px solid #E55943";
    } else if (props.$variant === "Santa's Special") {
      return "none";
    }
    return "0.5px solid #2876D7";
  }};

  display: flex;
  padding: 2px 12px 1px 12px;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 4px;
  color: ${(props) => {
    return "#fff";
  }};
  font-family: Figtree;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0.1px;
  line-height: 16px;
`;

export const Username = styled.div`
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
  font-family: Figtree;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.05px;
  white-space: nowrap;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ModelName = styled.div`
  color: #fff;
  text-align: center;
  font-family: Figtree;
  font-size: 18px;
  line-height: 20px;
  font-weight: 700;
  margin-bottom: -5px;
  letter-spacing: -0.1px;
`;

export const VideoFooter = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
  color: white;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.01) 80.05%,
    rgba(0, 0, 0, 0.7) 100%
  );
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 10;

  & > * {
    opacity: ${(props) => (props.$hideContent ? "0" : "1")};
    transform: translateY(${(props) => (props.$hideContent ? "20px" : "0")});
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
`;

export const GenerateButton = styled.button`
  position: absolute;
  bottom: ${(props) => (props.$show ? "20px" : "-60px")};
  left: 50%;
  transform: translateX(-50%);
  color: #333;
  border: none;
  cursor: pointer;
  opacity: ${(props) => (props.$show ? "1" : "0")};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 20;

  border-radius: 100px;
  background: #fff;

  display: flex;
  padding: 10px 24px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  color: #0f2c32;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.08px;

  &:hover {
    transform: translateX(-50%) scale(1.05);
  }

  &:active {
    transform: translateX(-50%) scale(0.98);
  }
`;

export const RunningText = styled.div`
  color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .running-title {
    color: #fff;
    text-align: center;
    font-family: Figtree;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: -0.09px;
  }

  .running-message {
    color: #fff;
    text-align: center;
    font-family: Figtree;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: -0.07px;
  }
`;

export const LoadingSpinnerBlur = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: ${(props) => (props.$show ? "flex" : "none")};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 5;
  height: 100%;
  width: 100%;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(23.1px);
  gap: 12px;

  l-line-spinner {
    --spinner-color: white;
  }
`;
